import { lazy } from "react";

export const lazyImport = (factory, name) =>
  lazy(() => factory().then((module) => ({ default: module[name] })));
